import React from 'react'
import { Layout, Stack, Main } from '@layout'
import PageTitle from '@components/PageTitle'
import Divider from '@components/Divider'
import Seo from '@widgets/Seo'
import AuthorExpanded from '@widgets/AuthorExpanded'
import { useBlogAuthors } from '@helpers-blog'

const Brands = props => {
    const authors = useBlogAuthors()
    return (
        <Layout {...props}>
            <Seo
                title='Brands'
                canonicalPath='/brands/'
                description='Our brands: Primula Dental, Primula Hair and Primula Derm – dentistry, hair transplants and dermatology in Antalya at a glance.'
            />
            <Divider />
            <Stack effectProps={{ effect: 'fadeInDown' }}>
                <PageTitle
                    header='Our Brands'
                    subheader='Primula Medical Travel offers different types of services for medical treatments on holiday. For easy distinction, we publish the content on our website under different brands, such as Primula Dental and Primula Hair.'
                />
            </Stack>
            <Stack>
                <Main>
                    {authors.map(author => (
                        <>
                            <Divider />
                            <AuthorExpanded author={author} withLink />
                        </>
                    ))}
                </Main>
            </Stack>
        </Layout>
    )
}
export default Brands;